export default {
    'name': 'minus',
    'width': '24',
    'height': '24',
    'viewBox': '0 0 24 24',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M21.75 11.2071C21.5813 11.0772 21.37 11 21.1406 11H2.85938C2.63003 11 2.41871 11.0772 2.25 11.2071V12.7929C2.41871 12.9228 2.63003 13 2.85938 13H21.1406C21.37 13 21.5813 12.9228 21.75 12.7929V11.2071Z\' fill=\'#006CFD\'/>'
}
